(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mainpage-image-layer-left"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    (function() {
      var selectors = {
        $image      : $('#image-layer-2'),
        $imageFrame : $('#image-layer-2').find('> .image-layer-frame'),
      }

      var variables = {
        controller : new ScrollMagic.Controller(),
        trigger    : selectors.$image.parent('.index-section__layered-image').prev('.index-section').eq(0).attr('id'),
      }

      if ( selectors.$image ) { 
        var imageLayer = new ScrollMagic.Scene({
          triggerElement: '#' + variables.trigger,
          duration: theme.variables.viewportHeight*2
        })
        .setTween(selectors.$imageFrame, {y:  -theme.variables.viewportHeight * 0.5 })    
        .triggerHook(0)
        .addTo(variables.controller);
      }
    })();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mainpage-image-layer-right"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    (function() {
      var selectors = {
        $image      : $('#image-layer-1'),
        $imageFrame : $('#image-layer-1').find('> .image-layer-frame'),
      }

      var variables = {
        controller : new ScrollMagic.Controller(),
        trigger    : selectors.$image.parent('.index-section__layered-image').prev('.index-section').eq(0).attr('id'),
      }

      if ( selectors.$image ) { 
        var imageLayer = new ScrollMagic.Scene({
          triggerElement: '#' + variables.trigger,
          duration: theme.variables.viewportHeight*2
        })
        .setTween(selectors.$imageFrame, {y:  -theme.variables.viewportHeight * 0.5 })    
        .triggerHook(0)
        .addTo(variables.controller);
      }
    })();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accessory-template"]) return;
  try {
    
$('.open-never-list').magnificPopup({
  type:'inline',
  midClick: true,
  items: {
    src: '#never-list'
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-giftcard-template"]) return;
  try {
    
$('.open-never-list').magnificPopup({
  type:'inline',
  midClick: true,
  items: {
    src: '#never-list'
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
$('.open-never-list').magnificPopup({
  type:'inline',
  midClick: true,
  items: {
    src: '#never-list'
  }
});

  } catch(e) { console.error(e); }
})();
})();
